export default __webpack_public_path__ + "static/media/help_modal_illustration.cb2ecb96.png";